import $ from 'jquery';
import { ManagePage } from '../Manage/_ManagePage.js';

// import { gsap } from 'gsap';

export default class UiBtnRestart {
  constructor() {
    $('.end_btn--restart').click(function (e) {
      ManagePage.reLoad();
      e.preventDefault();
    });
  }
}
